import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponentDialog } from '../confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
): Observable<boolean> | boolean => {
  if (component.canDeactivate()) {
    return true;
  }

  const dialog = inject(MatDialog);

  const dialogRef = dialog.open(ConfirmDialogComponentDialog, {
    data: {
      title: `Unsaved Changes`,
      message: `You made changes to the tenancy. Would you like to save them?`,
      actions: [
        { text: "Discard", result: true },
        { text: "Save Changes", result: false, color: "#1675C7" }
      ]
    },
    autoFocus: false
  });

  return dialogRef.afterClosed().pipe(
    map(result => !!result)
  );
};
